import AppEvents from 'lib/AppEvents';
import EventService from 'services/EventService';
import IDbOrCacheStore from 'stores/IDbOrCacheStore';
import { getLogger } from 'utils/logging';

const { log, warn } = getLogger('DataService', { color: 'green', enabled: false });

class DataService {
    private store: IDbOrCacheStore;

    constructor() {
        this.store = new IDbOrCacheStore("DS_");
        this.bindEvents();
    }

    public bindEvents = () => {
        EventService.subscribe(AppEvents.LOGIN, async () => {
            await this.clearData()
        });
        EventService.subscribe(AppEvents.LOGOUT, async (d) => {
            await this.clearData()
        });
    }

    public clearData = async () => {
        await this.store.clear();
    }

    // saves the data source in local storage, and memory, and notifies app of the update.
    public getDataSource = async (ids) => {
        const self = this;
        if (Array.isArray(ids)) {
            let results = {};
            // gets all sources at once
            await Promise.all(
                ids.map(async id => {
                    results[id] = await self.store.get(id);
                    //console.log('GOT DS', id, results[id]);
                    return results[id];
                    // return new Promise(async (resolve, reject) => {
                    //     results[id] = await self.store.get(id);
                    // })
                })
            )
            return results;
        } else {
            return await this.store.get(ids);
        }
    }

    // saves the data source in local storage, and memory, and notifies app of the update.
    public saveDataSource = async (id, data) => {
        log('DS.saveDataSource', [id])
        await this.store.set(id, data);
        EventService.dispatch(AppEvents.DATA_SOURCE_SAVED, { id, data });
    }

    // save a batch at once, and only fire one event for all
    public saveDataSources = async (dataSources) => {
        log('DS.saveDataSources', Array.isArray(dataSources) ? dataSources.map(d => d.id) : dataSources.id);

        if (Array.isArray(dataSources)) {
            await Promise.all(
                dataSources.map(ds => {
                    return new Promise(async (resolve, reject) => {
                        if (!ds) {
                            console.warn('Warning: Passed in data source is undefined.');
                            return resolve(null);
                        }
                        await this.store.set(ds.id, ds.data);
                        return resolve(ds);
                    });
                })
            );
        } else {
            await this.store.set(dataSources.id, dataSources.data);
        }

        EventService.dispatch(AppEvents.DATA_SOURCE_SAVED, dataSources);
    }

    public removeDataSource = async (id, emitEvent = true) => {
        await this.store.remove(id);
        if (emitEvent) {
            EventService.dispatch(AppEvents.DATA_SOURCE_REMOVED, id);
        }
    }

    public removeDataSources = async (dataSourceIds, emitEvent = true) => {
        await Promise.all(
            dataSourceIds.map(id => {
                return new Promise(async (resolve, reject) => {
                    await this.store.remove(id);
                    return resolve(true);
                });
            })
        );

        if (emitEvent) {
            EventService.dispatch(AppEvents.DATA_SOURCE_REMOVED, dataSourceIds);
        }
    }

}

export default new DataService();